export default "__VITE_ASSET__CZk99fTc__"